import { removeNull, asResultList, lockRowActions, applyFormerNames, fillBidProjectCode, resolveBidShortName, stripFormerNameSuffix, applyEntryTeams, matchOptionValue, uniqueIds, pickPersonUid, pickLaborTeamUid } from '@/utils/handleData.js'
import { buildFileList, buildSrcList } from '@/utils/signedDoc'
import { getLaborParentBidUid, isBuilderPersonOfCurrentOrg, isLaborCompanyOrg } from '@/utils/bidLevelActions.js'

function bidShortNameSources(rootState, rootGetters) {
  const bids =
    (rootState.bidSection && rootState.bidSection.subBidSection) || []
  const orgType = rootGetters && rootGetters['user/orgType']
  if (orgType !== 'simPro' || !rootState.user || !rootState.user.orgValue) {
    return bids
  }
  return bids.concat({
    value: rootState.user.orgValue,
    orgUid: rootState.user.orgValue,
    orgCode: (rootGetters && rootGetters['user/orgName']) || ''
  })
}
export default {
  namespaced: true,
  state: {
    laborPersonList: {}, // 缓存项目标段劳务人员列表当前页
    laborPersonInfo: {}, // 缓存项目标段劳务人员详情信息
    managePersonList: {}, // 缓存项目标段管理人员列表当前页
    managePersonInfo: {}, // 缓存项目标段管理人员详情信息
    // 劳务公司无薪酬统计权限时，列表不展示退场承诺书列
    showExitCommitmentCol: true
  },
  actions: {
    /** 按劳务公司 labor_admin 是否有薪酬统计，刷新退场承诺书列显隐 */
    async refreshExitCommitmentCol(
      { commit, dispatch, rootState, rootGetters },
      laborTeamUid
    ) {
      const orgType = rootGetters['user/orgType']
      let uid = laborTeamUid ? String(laborTeamUid).trim() : ''
      if (!uid && isLaborCompanyOrg(orgType)) {
        uid = rootState.user && rootState.user.orgValue
      }
      // 非劳务公司视角（企业/标段看多家）默认展示；劳务公司视角按权限
      if (!uid || !isLaborCompanyOrg(orgType)) {
        commit(
          'baseSet',
          { module: 'builder', key: 'showExitCommitmentCol', value: true },
          { root: true }
        )
        return true
      }
      const hasSalary = await dispatch(
        'role/laborAdminHasSalaryPayment',
        uid,
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'builder',
          key: 'showExitCommitmentCol',
          value: !!hasSalary
        },
        { root: true }
      )
      return !!hasSalary
    },
    // 根据合同uid获取劳务人员进场日期
    async getLaborWorkinDate({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/laborperson/walkindate',
          data: { contractUid: uid }
        },
        { root: true }
      )
      return res && res.data ? res.data : ''
    },
    // 劳务人员进场
    async addLaborPerson({ dispatch }, data) {
      const payload = Array.isArray(data) ? data[0] : data
      if (payload) {
        const teamUids = uniqueIds(
          Array.isArray(payload.teamUids) && payload.teamUids.length
            ? payload.teamUids
            : payload.teamUid
        )
        payload.teamUids = teamUids
        payload.teamUid = teamUids[0] || payload.teamUid || ''
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/worker/labor',
          data: payload,
          msg: '劳务人员进场成功'
        },
        { root: true }
      )
      return res
    },
    // 删除劳务人员
    async deleteLaborPerson({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/worker/labor',
          data: { uid: uid },
          msg: '删除劳务人员成功'
        },
        { root: true }
      )
      return res
    },
    async checkLaborPersonDeletable({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/worker/labor/canremove',
          data: { uid: uid },
          noErrorMsg: true
        },
        { root: true }
      )
      return res && res.data ? res.data : {}
    },
    // 获取劳务人员列表
    async getLaborPersonList({ rootState, rootGetters, commit, dispatch }) {
      const ensured = await dispatch(
        'bidSection/ensureDefaultBidQuery',
        { queryKey: 'laborPerson', fieldKey: 'vProjectUid' },
        { root: true }
      )
      const q = Object.assign({}, ensured || rootState.queryValues.laborPerson || {})
      if (rootGetters['user/orgType'] === 'laborCom') {
        const bidUid = getLaborParentBidUid({
          orgType: 'laborCom',
          orgValue: rootState.user.orgValue,
          state: rootState,
          getters: rootGetters
        })
        q.organUid = bidUid || rootState.user.orgValue
        q.vProjectUid = bidUid || ''
        q.laborTeamUid = rootState.user.orgValue
      }
      const queryValues = removeNull({
        organUid: q.organUid || rootState.user.orgValue,
        vProjectUid: q.vProjectUid,
        laborTeamUid: q.laborTeamUid,
        teamUid: q.teamUid,
        businessUid: q.businessUid,
        isExit: q.isExit,
        ageUid: q.ageUid,
        query: q.query,
        page: rootState.page.laborPerson || 1,
        limit: rootState.limit.laborPerson || 10
      })
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/buildtype/laborperson',
          data: queryValues
        },
        { root: true }
      )
      var laborPersonList = res && res.data ? res.data : {}
      laborPersonList.result = asResultList(laborPersonList)
      laborPersonList.result.forEach((item) => {
        if (!item) return
        item.personUid = pickPersonUid(item)
        item.laborTeamUid = pickLaborTeamUid(item) || item.laborTeamUid || ''
      })
      const isSuperAdmin = rootState.user.userName === rootState.superAdminName
      if (laborPersonList.result && laborPersonList.result.length) {
        const personUids = laborPersonList.result
          .map((item) => pickPersonUid(item))
          .filter((item) => item)
        if (personUids.length) {
          try {
            const extra = await dispatch(
              'baseRequest',
              {
                method: 'GET',
                url: '/person/list/personinfo/archivestatus',
                data: { uids: personUids.join(',') },
                noErrorMsg: true
              },
              { root: true }
            )
            applyFormerNames(
              laborPersonList.result,
              Array.isArray(extra && extra.data) ? extra.data : []
            )
          } catch (e) {
            /* 附加信息失败不影响列表展示 */
          }
        }
        const entryUids = laborPersonList.result
          .map((item) => item.uid)
          .filter((item) => item)
        if (entryUids.length) {
          try {
            const teamRes = await dispatch(
              'baseRequest',
              {
                method: 'GET',
                url: '/person/worker/laborteams',
                data: { entryUids: entryUids.join(',') },
                noErrorMsg: true
              },
              { root: true }
            )
            applyEntryTeams(
              laborPersonList.result,
              Array.isArray(teamRes && teamRes.data) ? teamRes.data : []
            )
          } catch (e) {
            /* 班组绑定查询失败不影响列表展示 */
          }
        }
      }
      laborPersonList.result = laborPersonList.result || []
      laborPersonList.result.forEach((item) => {
        item.disabledButtons = []
        item.warnButtons = []
        if (item.noteInfo !== '在场' && !item.picUid) {
          item.warnButtons = [0, '', '', '', '']
        }
        if (!item.walkoffDate) {
          item.walkoffDate = '未退场'
        }
        if (item.currentStatus === '1') {
          item.walkoffDate = '退场确认中'
        }
        const orgType = rootGetters['user/orgType']
        // 劳务公司级列表已按本单位过滤，不禁用编辑/删除/退场；退场等校验在点击时处理
        if (!isLaborCompanyOrg(orgType)) {
          lockRowActions(
            item,
            !isBuilderPersonOfCurrentOrg(
              item,
              orgType,
              rootState.user.orgValue
            ),
            isSuperAdmin
          )
        }
        const bids = rootState.bidSection.subBidSection || []
        fillBidProjectCode(item, bids)
        item.companyName = stripFormerNameSuffix(item.companyName)
        if (!item.picUid) {
          item.isPic = false
          item.picStatus = '预览承诺书'
          item.srcList = []
        } else {
          item.isPic = true
          item.picStatus = '承诺书图片'
          item.srcList = buildSrcList({ state: rootState }, item.picUid)
        }
      })
      commit(
        'baseSet',
        { module: 'builder', key: 'laborPersonList', value: laborPersonList },
        { root: true }
      )
    },
    async fetchLaborPersonDetail({ dispatch }, laborUid) {
      if (!laborUid) return {}
      const tryDetail = async (url) => {
        try {
          const res = await dispatch(
            'baseRequest',
            {
              method: 'GET',
              url,
              data: { laborUid },
              noErrorMsg: true
            },
            { root: true }
          )
          return res && res.data && typeof res.data === 'object' ? res.data : {}
        } catch (e) {
          return {}
        }
      }
      let data = await tryDetail('/query/buildtype/laborpersondetail')
      if (!data.name && !data.personName && !data.personUid) {
        const fallback = await tryDetail('/udf/buildtype/laborpersondetail')
        if (fallback && (fallback.name || fallback.personName || fallback.personUid)) {
          data = fallback
        }
      }
      return data
    },
    // 获取劳务人员进退场信息
    async getLaborPersonInfo({ rootState, rootGetters, commit, dispatch }, uid) {
      const laborUid =
        (uid && typeof uid === 'object' ? uid.uid || uid.laborUid : uid) || ''
      const row =
        (rootState.currentRow && rootState.currentRow.laborPerson) || {}
      const data = await dispatch('fetchLaborPersonDetail', laborUid)
      var laborPersonInfo = Object.assign({}, row, data)
      laborPersonInfo.uid = laborUid || laborPersonInfo.uid || row.uid || ''
      laborPersonInfo.personName =
        laborPersonInfo.personName ||
        laborPersonInfo.name ||
        row.personName ||
        row.name ||
        ''
      laborPersonInfo.laborTeamName =
        laborPersonInfo.laborTeamName ||
        laborPersonInfo.companyName ||
        row.laborTeamName ||
        row.companyName ||
        ''
      laborPersonInfo.vProjectName =
        laborPersonInfo.vProjectName ||
        laborPersonInfo.projectName ||
        row.vProjectName ||
        row.projectName ||
        row.projectCode ||
        ''
      laborPersonInfo.projectUid =
        laborPersonInfo.projectUid ||
        laborPersonInfo.orgUid ||
        laborPersonInfo.upVproUid ||
        laborPersonInfo.vProjectUid ||
        row.projectUid ||
        row.orgUid ||
        row.vProjectUid ||
        ''
      laborPersonInfo.vProjectUid =
        laborPersonInfo.vProjectUid ||
        laborPersonInfo.upVproUid ||
        laborPersonInfo.projectUid ||
        row.vProjectUid ||
        row.upVproUid ||
        row.projectUid ||
        ''
      laborPersonInfo.upVproUid =
        laborPersonInfo.upVproUid || laborPersonInfo.vProjectUid || ''
      laborPersonInfo.isLeader =
        laborPersonInfo.isLeader || laborPersonInfo.isForeman || ''
      const rawForeman = laborPersonInfo.isForeman
      if (
        rawForeman === '否' ||
        rawForeman === '0' ||
        rawForeman === 0 ||
        rawForeman === false
      ) {
        laborPersonInfo.isForeman = '0'
      } else if (
        rawForeman === '是' ||
        rawForeman === '1' ||
        rawForeman === 1 ||
        rawForeman === true
      ) {
        laborPersonInfo.isForeman = '1'
      } else {
        laborPersonInfo.isForeman = rawForeman || '0'
      }
      laborPersonInfo.walkoffReason = laborPersonInfo.walkoffReason || ''
      const rawWalkoff = String(laborPersonInfo.walkoffDate || '').trim()
      const walkoffMatch = rawWalkoff.match(/^(\d{4}-\d{2}-\d{2})/)
      laborPersonInfo.walkoffDate = walkoffMatch ? walkoffMatch[1] : ''
      laborPersonInfo.personUid =
        pickPersonUid(laborPersonInfo) ||
        pickPersonUid(data) ||
        pickPersonUid(row) ||
        ''
      laborPersonInfo.laborTeamUid =
        pickLaborTeamUid(laborPersonInfo) ||
        pickLaborTeamUid(data) ||
        pickLaborTeamUid(row) ||
        ''
      laborPersonInfo.cardUid =
        laborPersonInfo.cardUid || laborPersonInfo.carduid || ''
      laborPersonInfo.backCard =
        laborPersonInfo.backCard || laborPersonInfo.cardNum || ''
      laborPersonInfo.fileLists = {
        electronicSignature: [],
        picUid: [],
        commitmentLetter: []
      }
      laborPersonInfo.srcList = []
      // 详情/行数据字段名不统一时兼容；签名图 uid 在匹配选项后再写入 fileLists
      laborPersonInfo.electronicSignature =
        laborPersonInfo.electronicSignature ||
        laborPersonInfo.signatureUid ||
        laborPersonInfo.electorGrade ||
        laborPersonInfo.elecAutographUid ||
        ''
      if (laborPersonInfo.picUid) {
        laborPersonInfo.fileLists.picUid = buildFileList(
          { state: rootState },
          laborPersonInfo.picUid,
          (laborPersonInfo.personName || '') + '退场承诺书'
        )
        laborPersonInfo.srcList = buildSrcList(
          { state: rootState },
          laborPersonInfo.picUid
        )
      }
      let qcodeUrl =
        laborPersonInfo.qcode || laborPersonInfo.qcodeUrl || data.qcode || ''
      if (!qcodeUrl && laborPersonInfo.personUid) {
        try {
          const qr = await dispatch(
            'person/getPersonQcode',
            laborPersonInfo.personUid,
            { root: true }
          )
          qcodeUrl = (qr && (qr.qcodeUrl || qr.qcode)) || ''
        } catch (e) {
          qcodeUrl = ''
        }
      }
      laborPersonInfo.qcodeInfo = {
        qcodeUrl: qcodeUrl || laborPersonInfo.uid,
        qcodeName: laborPersonInfo.personName,
        project: resolveBidShortName(
          laborPersonInfo,
          bidShortNameSources(rootState, rootGetters)
        ),
        leftText: '平安工地',
        rightText: '以人为本'
      }
      let teamRes = {}
      try {
        teamRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/person/worker/laborteams',
            data: { entryUid: laborPersonInfo.uid },
            noErrorMsg: true
          },
          { root: true }
        )
      } catch (e) {
        teamRes = {}
      }
      applyEntryTeams(
        [laborPersonInfo],
        Array.isArray(teamRes && teamRes.data) ? teamRes.data : []
      )
      if (!pickPersonUid(laborPersonInfo)) {
        const teams = Array.isArray(teamRes && teamRes.data) ? teamRes.data : []
        const hit =
          teams.find((item) => {
            const entryUid = item && (item.entryUid || item.entryuid)
            return entryUid && String(entryUid) === String(laborPersonInfo.uid)
          }) || teams[0]
        laborPersonInfo.personUid = pickPersonUid(hit)
        if (!pickLaborTeamUid(laborPersonInfo)) {
          laborPersonInfo.laborTeamUid = pickLaborTeamUid(hit)
        }
      }
      if (!pickPersonUid(laborPersonInfo) && laborPersonInfo.uid) {
        try {
          const uidRes = await dispatch(
            'baseRequest',
            {
              method: 'GET',
              url: '/person/worker/labor/personuid',
              data: { uid: laborPersonInfo.uid },
              noErrorMsg: true
            },
            { root: true }
          )
          laborPersonInfo.personUid =
            pickPersonUid(uidRes && uidRes.data) ||
            (uidRes && typeof uidRes.data === 'string' ? uidRes.data : '')
        } catch (e) {
          /* 进场记录反查失败时仍返回已有详情 */
        }
      }
      laborPersonInfo.teamUids = uniqueIds(
        Array.isArray(laborPersonInfo.teamUids) &&
          laborPersonInfo.teamUids.length
          ? laborPersonInfo.teamUids
          : laborPersonInfo.teamUid
      )
      if (laborPersonInfo.personUid) {
        const cards = await dispatch(
          'person/getBackCard',
          laborPersonInfo.personUid,
          { root: true }
        )
        const sigs = await dispatch(
          'person/getPersonSignature',
          laborPersonInfo.personUid,
          { root: true }
        )
        laborPersonInfo.cardUid = matchOptionValue(
          cards,
          laborPersonInfo.cardUid
        )
        laborPersonInfo.electronicSignature = matchOptionValue(
          sigs,
          laborPersonInfo.electronicSignature
        )
        // 进场未存 electronicSignature、但个人档案已绑定唯一签名时回显
        if (
          !laborPersonInfo.electronicSignature &&
          Array.isArray(sigs) &&
          sigs.length === 1 &&
          sigs[0] &&
          sigs[0].value
        ) {
          laborPersonInfo.electronicSignature = sigs[0].value
        }
        const sig = (sigs || []).find((item) => {
          if (!item || !laborPersonInfo.electronicSignature) return false
          const cur = String(laborPersonInfo.electronicSignature)
          return (
            String(item.value) === cur ||
            String(item.signatureUid || '') === cur ||
            String(item.uid || '') === cur
          )
        })
        if (sig) {
          laborPersonInfo.electorName = sig.label || sig.electorName || ''
          // 回显/预览必须用签名图 uid，不能用签名记录 uid
          laborPersonInfo.electronicSignature =
            sig.signatureUid || sig.value || laborPersonInfo.electronicSignature
        }
      }
      if (laborPersonInfo.electronicSignature) {
        commit(
          'pictureSet',
          {
            key: 'electronicSignature',
            value: [laborPersonInfo.electronicSignature],
            type: 'signature'
          },
          { root: true }
        )
        laborPersonInfo.fileLists.electronicSignature =
          rootState.pictures.electronicSignature || []
      }
      if (laborPersonInfo.laborTeamUid) {
        await dispatch(
          'contractor/getTeamNames',
          laborPersonInfo.laborTeamUid,
          { root: true }
        )
      }
      commit(
        'baseSet',
        { module: 'builder', key: 'laborPersonInfo', value: laborPersonInfo },
        { root: true }
      )
      return laborPersonInfo
    },
    // 编辑劳务人员
    async editLaborPerson({ dispatch }, data) {
      const payload = data && !Array.isArray(data) ? data : null
      if (payload) {
        const teamUids = uniqueIds(
          Array.isArray(payload.teamUids) && payload.teamUids.length
            ? payload.teamUids
            : payload.teamUid
        )
        payload.teamUids = teamUids
        payload.teamUid = teamUids[0] || payload.teamUid || ''
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/worker/labor',
          data: data,
          msg: '编辑劳务人员成功'
        },
        { root: true }
      )
      return res
    },
    // 劳务人员退场
    async exitLaborPerson({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/worker/laborOut',
          data: data,
          msg: '劳务人员退场成功'
        },
        { root: true }
      )
      return res
    },
    // 上传退场承诺书图片uid
    async uploadLaboroutpic({ dispatch }, data) {
      const payload = Object.assign({}, data || {})
      const silent = payload.notify === false
      delete payload.notify
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/worker/laboroutpic',
          data: payload,
          msg: silent ? undefined : '上传退场承诺书图片成功'
        },
        { root: true }
      )
      return res
    },
    // 管理人员进场
    async addManagePerson({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/manager/admin',
          data: data,
          msg: '管理人员进场成功'
        },
        { root: true }
      )
      return res
    },
    // 删除管理人员
    async deleteManagePerson({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/manager/admin',
          data: { uid: uid },
          msg: '删除管理人员成功'
        },
        { root: true }
      )
      return res
    },
    async checkManagePersonDeletable({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/manager/admin/canremove',
          data: { uid: uid },
          noErrorMsg: true
        },
        { root: true }
      )
      return res && res.data ? res.data : {}
    },
    async getManagePersonList({ rootState, rootGetters, commit, dispatch }) {
      var queryValues = await dispatch(
        'bidSection/ensureDefaultBidQuery',
        { queryKey: 'managePerson', fieldKey: 'vProjectUid' },
        { root: true }
      )
      queryValues = Object.assign({}, queryValues)
      queryValues.page = rootState.page.managePerson
      queryValues.limit = rootState.limit.managePerson
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/buildtype/adminperson',
          data: queryValues
        },
        { root: true }
      )
      var managePersonList = res.data ? res.data : {}
      managePersonList.result = asResultList(managePersonList)
      const isSuperAdmin = rootState.user.userName === rootState.superAdminName
      if (managePersonList.result && managePersonList.result.length) {
        const personUids = managePersonList.result
          .map((item) => item.personUid)
          .filter((item) => item)
        if (personUids.length) {
          const extra = await dispatch(
            'baseRequest',
            {
              method: 'GET',
              url: '/person/list/personinfo/archivestatus',
              data: { uids: personUids.join(',') },
              noErrorMsg: true
            },
            { root: true }
          )
          applyFormerNames(
            managePersonList.result,
            Array.isArray(extra && extra.data) ? extra.data : []
          )
        }
      }
      managePersonList.result = managePersonList.result || []
      managePersonList.result = managePersonList.result || []
      managePersonList.result.forEach((item) => {
        item.disabledButtons = []
        lockRowActions(
          item,
          !isBuilderPersonOfCurrentOrg(
            item,
            rootGetters['user/orgType'],
            rootState.user.orgValue
          ),
          isSuperAdmin
        )
        const bids = rootState.bidSection.subBidSection || []
        fillBidProjectCode(item, bids)
        item.companyName = stripFormerNameSuffix(item.companyName)
        item.entryDate = item.walkinDate
      })
      commit(
        'baseSet',
        { module: 'builder', key: 'managePersonList', value: managePersonList },
        { root: true }
      )
    },
    // 获取管理人员进退场信息
    async getManagePersonInfo({ rootState, rootGetters, commit, dispatch }, uid) {
      let res = {}
      try {
        res =
          (await dispatch(
            'baseRequest',
            {
              method: 'GET',
              url: '/query/buildtype/adminpersondetail',
              data: { adminUid: uid },
              noErrorMsg: true
            },
            { root: true }
          )) || {}
      } catch (e) {
        res = {}
      }
      if (!res.data || (!res.data.personName && !res.data.personUid)) {
        try {
          const fallback = await dispatch(
            'baseRequest',
            {
              method: 'GET',
              url: '/udf/buildtype/adminpersondetail',
              data: { adminUid: uid },
              noErrorMsg: true
            },
            { root: true }
          )
          if (fallback && fallback.data) res = fallback
        } catch (e) {
          /* 保留已取到的结果 */
        }
      }
      var managePersonInfo = res.data ? res.data : {}
      managePersonInfo.uid = uid
      managePersonInfo.projectUid =
        managePersonInfo.projectUid ||
        managePersonInfo.vProjectUid ||
        managePersonInfo.orgUid ||
        (rootState.currentRow &&
          rootState.currentRow.managePerson &&
          (rootState.currentRow.managePerson.vProjectUid ||
            rootState.currentRow.managePerson.orgUid)) ||
        ''
      managePersonInfo.entryDate = managePersonInfo.walkinDate
      managePersonInfo.employMethod = managePersonInfo.employmentMethod
      managePersonInfo.jobTitleName = managePersonInfo.jobTitle
      managePersonInfo.jobTitle = managePersonInfo.jobTitleUid
      managePersonInfo.exitDate = managePersonInfo.walkoffDate
      managePersonInfo.exitReason = managePersonInfo.walkoffReason
      managePersonInfo.fileLists = {
        elecAutographUid: []
      }
      if (managePersonInfo.elecAutographUid) {
        commit(
          'pictureSet',
          {
            key: 'elecAutographUid',
            value: [managePersonInfo.elecAutographUid],
            type: 'signature'
          },
          { root: true }
        )
        managePersonInfo.fileLists.elecAutographUid =
          rootState.pictures.elecAutographUid || []
      }
      managePersonInfo.qcodeInfo = {
        qcodeUrl: managePersonInfo.qcode || uid,
        qcodeName: managePersonInfo.personName,
        project: resolveBidShortName(
          managePersonInfo,
          bidShortNameSources(rootState, rootGetters)
        ),
        leftText: '平安工地',
        rightText: '以人为本'
      }
      commit(
        'baseSet',
        { module: 'builder', key: 'managePersonInfo', value: managePersonInfo },
        { root: true }
      )
      return managePersonInfo
    },
    // 编辑管理人员
    async editManagePerson({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/manager/adminedit',
          data: data,
          msg: '编辑管理人员成功'
        },
        { root: true }
      )
      return res
    },
    // 管理人员退场
    async exitManagePerson({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/manager/admin',
          data: data,
          msg: '管理人员退场成功'
        },
        { root: true }
      )
      return res
    }
  }
}
